import React from "react";
import InternalServer from "./InternalServerError";
import { ErrorBoundary } from "react-error-boundary";

const isServer = typeof window === "undefined";
const HandleError = (props) => {
  const consoleMyError = (e) => {
    let ErrorDetails = {
    //   componentName:props.children?.type?.name,
    //   componentProps:props.children?.props,
      error:e,
    //   parentComponent:props.children?._owner?.elementType?.name
    }
    console.error(`%cERROR FROM ERROR BOUNDARY   >>>  error found in`, "color: #26bfa5;", ErrorDetails)
  }
  
  // if(isServer){
  //     try{
  //         return(
  //             <>{props.children}</>
  //         )
  //     }
  //     catch(error){
  //         return <ErrorFallback error={error}/>
  //     }
  // }
  // else{
  return (
    <ErrorBoundary FallbackComponent={() => <InternalServer/>} onError={(e) => consoleMyError(e)}>
      <>{props.children}</>
    </ErrorBoundary>
  );
  // }
};
export default HandleError;
